import { render, staticRenderFns } from "./group-addmember.vue?vue&type=template&id=95529be0"
import script from "./group-addmember.vue?vue&type=script&lang=js"
export * from "./group-addmember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports